import React from 'react'

const ApproachSection: React.FC = () => {
  return (
    <section className="py-20" style={{ backgroundColor: 'var(--background)' }}>
      <div className="max-w-7xl mx-auto px-6">
        <div className="approach-block">
          <div className="approach-content">
            <h2 className="text-2xl font-light mb-8">Our Approach</h2>
            
            <div className="approach-item">
              "Outcome-focused delivery"
            </div>
            <div className="approach-item">
              "Security-first mindset"
            </div>
            <div className="approach-item">
              "AI-powered innovation"
            </div>
            <div className="approach-item">
              "Team empowerment"
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ApproachSection